<template>
  <div class="bg-white w-full rounded-lg mt-1">
    <div class="p-7">
      <div v-for="section in detailSections" :key="section.title" class="mb-8 last:mb-0">
        <TitleWrapper
          :filter-option="false"
          :title="section.title"
          :tooltip-title="section.tooltip"
          :display-breadcrumb="false"
        />
        <DetailCard :details="section.details" custom-classes="flex-col" class="mt-5" />
      </div>
    </div>
    <StaffModal
      v-if="showModal"
      :modal="showModal"
      :edit="currentUser"
      @toggle="toggleStaffModal"
    ></StaffModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import TitleWrapper from '@components/TitleWrapper.vue'
import DetailCard from '@src/components/UiElements/DetailCard.vue'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import StaffModal from '@/src/router/views/admin/modals/StaffModal.vue'
import GENERAL_CONSTANTS from '@src/constants/general-constants.js'
export default {
  components: {
    TitleWrapper,
    DetailCard,
    StaffModal,
  },
  data() {
    return {
      GENERAL_CONSTANTS,
      currentUser: null,
      dashboard: 'dashboard',
      title: 'title',
    }
  },
  page: {
    title: 'User Profile',
    meta: [{ name: 'description', content: 'Profile for User of MyQampus' }],
  },
  computed: {
    ...mapState({
      showModal: (state) => state.layout.showModal,
    }),
    ...mapGetters('auth', ['userImage']),
    personalDetails() {
      const profile = this.currentUser?.profile || {}
      const firstName = this.currentUser?.first_name || ''
      const lastName = this.currentUser?.last_name || ''
      const fullName = `${firstName} ${lastName}`.trim()

      return {
        name: fullName || GENERAL_CONSTANTS.NOT_APPLICABLE,
        gender: this.currentUser?.gender || GENERAL_CONSTANTS.NOT_APPLICABLE,
        bloodGroup: profile?.blood_group || GENERAL_CONSTANTS.NOT_APPLICABLE,
        dateOfBirth: profile?.date_of_birth || GENERAL_CONSTANTS.NOT_APPLICABLE,
        nationality: profile?.nationality || GENERAL_CONSTANTS.NOT_APPLICABLE,
      }
    },
    contactDetails() {
      const profile = this.currentUser?.profile || {}
      return {
        phone: this.currentUser?.phone || GENERAL_CONSTANTS.NOT_APPLICABLE,
        email: this.currentUser?.email || GENERAL_CONSTANTS.NOT_APPLICABLE,
        address: profile?.address || GENERAL_CONSTANTS.NOT_APPLICABLE,
      }
    },
    detailSections() {
      return [
        {
          title: 'PERSONAL_INFO',
          tooltip: 'PERSONAL_INFO',
          details: this.personalDetails,
        },
        {
          title: 'CON_INFO',
          tooltip: 'CON_INFO',
          details: this.contactDetails,
        },
      ]
    },
  },
  watch: {
    currentUser: {
      immediate: true,
      handler() {
        this.setRightbarData()
      },
    },
  },
  created() {
    this.currentUser = JSON.parse(localStorage.getItem('auth.currentUser'))
    this.setRightbarData()
  },
  methods: {
    toggleStaffModal() {
      this.setShowModal()
    },
    setRightbarData() {
      const rightBarContent = {
        header: {
          title: 'Profile Details',
          buttons: [
            {
              title: 'Edit Profile',
              classes: ['primary-button-right'],
              action: { name: 'layout/setShowModal' },
              permissions: { roles: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN] },
            },
          ],
        },
        stats: [],
        profileInfo: [
          {
            imageUrl: this.userImage || null,
          },
        ],
      }
      this.setRightbarContent(rightBarContent)
    },
    ...mapActions('layout', ['setRightbarContent', 'setShowModal']),
  },
}
</script>
